import toggleOtherField from "./incident_form_handler/toggleOtherField";
import toggleSecurityIncidentsSection from "./incident_form_handler/toggleSecurityIncidentsSection";
import toggleOverdoseSection from "./incident_form_handler/toggleOverdoseSection";
import overdoseSectionToggleOtherTreatmentType from "./incident_form_handler/overdoseSectionToggleOtherTreatmentType";
import updateNatureOfInjuryOfInjury from "./incident_form_handler/updateNatureOfInjuryOfInjury";
import toggleInjuryExplain from "./incident_form_handler/toggleInjuryExplain";
import toggleOverdoseDetailCheckbox from "./incident_form_handler/toggleOverdoseDetailCheckbox";
import toggleStaffInjuredMessage from "./incident_form_handler/toggleStaffInjuredMessage";
import toggleMedicalEmergencySection from "./incident_form_handler/toggleMedicalEmergencySection";
document.addEventListener("DOMContentLoaded", () => {
  const checkboxes = [
    "#incident_report_incident_is_fall_or_minor_accident_injury",
    "#incident_report_incident_is_fall_or_minor_accident_no_injury",
    "#incident_report_incident_is_medication_error_administration",
    "#incident_report_incident_is_medication_error_not_documented_correctly",
    "#incident_report_incident_is_safety_security_conduct",
    "#incident_report_incident_is_skin_tissue_laceration_or_abrasion",
    "#incident_report_incident_is_assault_violence_fight_or_other_security_incident",
    "#incident_report_incident_is_other",
    "#is-medical-emergency-subtype"
  ];

  checkboxes.forEach((checkbox) => {
    $(document).on("click", checkbox, () => {
      checkboxes.forEach((otherCheckbox) => {
        if (otherCheckbox !== checkbox) {
          $(otherCheckbox).prop("checked", false);
          $(otherCheckbox).trigger("change");
        }
      });
    });
  });
  toggleOtherField();
  toggleInjuryExplain();
  toggleOverdoseSection();
  overdoseSectionToggleOtherTreatmentType();
  updateNatureOfInjuryOfInjury();
  toggleSecurityIncidentsSection();
  toggleOverdoseDetailCheckbox();
  toggleStaffInjuredMessage();
  toggleMedicalEmergencySection();

  $("#delete-incident-report-btn").on("click", function (e) {
    e.preventDefault();
    if (confirm("Are you sure you want to delete this incident report?")) {
      $("#delete-form").submit();
    }
  });
});
